"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLegend = void 0;
var _Legend = require("./Legend");
// TODO: in v9, move styled() from Legend.jsx to here
var StyledLegend = _Legend.Legend;
exports.StyledLegend = StyledLegend;